import {cusConsult, getPhoneCode, loginCode, loginPass, logOut} from '@/api/index.js';
import {router, vm} from '@/main.js';
import Vue from 'vue';

const state = {
  codeForm: {
    mobie: '',
    code: '',
    register: '',
  },

  passForm: {
    mobie: '',
    password: '',
  },
  contactForm: {
    enterpriseName: '',
    contacts: '',
    contactPhone: '',
    email: '',
    cooperateContent: '',
  },
  codeContent: '获取验证码',

  codeTime: 120,
  codeTime2: 120,
  canClick: true,
  canClick2: true,
  clock: '',
  clock2: '',
  fileSize: 30, //限制上传文件大小 M单位
};

const getters = {};

const mutations = {
  sendLoginPassMutations(state) {
    let currentTime = Vue.prototype.U.timestamp().timeTogether;
    logOut().then((resL) => {
      if (resL.code == 0 || resL.code == 10000) {
        let mobie = state.passForm.mobie.replace(/(^\s*)|(\s*$)/g, '');
        let password = state.passForm.password.replace(/(^\s*)|(\s*$)/g, '');
        console.log('mobie', mobie);
        console.log('password', password);
        console.log('state.passForm', state.passForm);
        loginPass({
          currentTime: currentTime + '',
          mobie,
          password,
        }).then((res) => {
          state.canClick = true;
          state.codeContent = '获取验证码';
          clearInterval(state.clock);
          res.data['cusUserId'] = res.data.id;
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data));
          sessionStorage.setItem('accountInfo', JSON.stringify(res.data));
          sessionStorage.setItem('tutorialHints', res.data.tutorialHintsNumber);
          sessionStorage.setItem('bclosingBit', true);
          router.push({
            name: 'Order',
            params: {id: res.data.id, orderDraftId: res.data.orderDraftId},
          });
        });
      }
    });
  },
  sendLoginCodeMutations(state) {
    let currentTime = Vue.prototype.U.timestamp().timeTogether;
    logOut().then((resL) => {
      if (resL.code == 0 || resL.code == 10000) {
        console.log('state.codeForm', state.codeForm);
        loginCode({
          currentTime: currentTime + '',
          ...state.codeForm,
        }).then((res) => {
          state.canClick = true;
          state.codeContent = '获取验证码';
          clearInterval(state.clock);
          res.data['id'] = res.data.cusUserId;
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data));
          sessionStorage.setItem('accountInfo', JSON.stringify(res.data));
          sessionStorage.setItem('bclosingBit', true);
          router.push({name: 'Order', params: {id: res.data.id}});
        });
      }
    });
  },
  sendContactMutations(state) {
    if (state.contactForm.enterpriseName == '') {
      vm.$message.error('企业名称不能为空！');
      return;
    }

    // if(state.contactForm.contacts == '') {
    //   vm.$message.error('邮箱不能为空！');
    //   return;
    // }

    var myreg = /^((1[0-9]{1})+\d{9})$/;

    if (state.contactForm.contactPhone == '') {
      vm.$message.error('手机号码不能为空！');
      return;
    }
    if (!myreg.test(state.contactForm.contactPhone)) {
      vm.$message.error('手机号码格式不正确！');
      return;
    }
    cusConsult(state.contactForm).then((res) => {
      for (let key in state.contactForm) {
        state.contactForm[key] = '';
      }
      vm.$message.success(res.msg);
    });
  },
};
// function reTirm(s) {
//   return s.replace(/(^\s*)|(\s*$)/g, "");
// }
const actions = {
  // 获取验证码 2025年10月14日 14:47:15
  getCodeActions({commit, state}, postData) {
    state.codeTime = 120;
    console.log('getCodeMutations postData', postData);
    // return;
    getPhoneCode(postData).then((res) => {
      if (res.code === 0) {
        if (!state.canClick) {
          window.clearInterval(state.clock);
          state.codeContent = '重新发送';
          state.codeTime = 120;
          state.canClick = true;
          return;
        }
        state.canClick = false;
        state.codeContent = state.codeTime + ' s';
        state.clock = window.setInterval(() => {
          state.codeTime--;
          state.codeContent = state.codeTime + ' s';
          if (state.codeTime < 0) {
            window.clearInterval(state.clock);
            state.codeContent = '重新发送';
            state.codeTime = 120;
            state.canClick = true;
          }
        }, 1000);
        vm.$message.success(res.msg);
      } else {
        vm.$message.error(res.msg);
      }
    });
  },

  sendLoginCodeActions(context) {
    context.commit('sendLoginCodeMutations');
  },
  sendContactActions(context) {
    context.commit('sendContactMutations');
  },
  sendLoginPassActions(context) {
    context.commit('sendLoginPassMutations');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js